export enum AUTH_STORAGE_TOKENS {
  AUTH = '@auth'
}
